import React, {
	useEffect,
	useState,
	useCallback,
	useLayoutEffect,
	forwardRef,
} from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
	languageSetting,
	translatedText,
} from '../recoil-states/language-state';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import mypage_ico from '../assets/icons/mypage_ico.svg';
import logout_ico from '../assets/icons/logout_ico.svg';
import logo from '../assets/icons/logo_mini.svg';
import globe from '../assets/icons/globe.svg';
import 'react-spring-modal/styles.css';
import { isMobile } from 'react-device-detect';
// author : 유동우
// date : 2022/07/06
// blockchain
import {
	InnerModalOpen,
	isLoggedAccount,
	isSessionSaved,
	Login,
	membership_rank,
	wallet,
	WalletConnectModalOpen,
} from '../recoil-states/user-state/user-state';
import Language from './Language';
import HeaderMobile from './HeaderMobile';
import {
	decryptedData,
	decryptedData_string,
	encryptedData,
	post_Email_Login,
	post_Wallet_Linking,
	post_Wallet_unlinking,
	_getMembershipRank,
	_inputActionLog,
} from '../function/functions';
import { ethers } from 'ethers';
import StakeModal from './StakeModal';
import profileImg from '../assets/default_profile.png';
import OAuthModal from './OAuthModal';
import WalletConnectModal from './WalletConnectModal';
import {
	OAuthData,
	OAuthDataState,
} from '../recoil-states/user-state/user-OAuth';
import { NavHashLink } from 'react-router-hash-link';
import Loading from './Loading';
import '@reach/dialog/styles.css';
import {
	useAccount,
	useConnect,
	useDisconnect,
	useNetwork,
	useProvider,
	useSignMessage,
} from 'wagmi';
import { connectors, web3AuthInstance } from '..';

const Header = forwardRef(
	({ colortype, windowWidth, roadmap, handleAuth }, mobileHeaderRef) => {
		const { isConnected, address } = useAccount();
		const { disconnectAsync } = useDisconnect();

		const [userData, setUserData] = useRecoilState(OAuthData);
		const [langmChange, setlangmChange] = useRecoilState(languageSetting);
		const [userMembership, setUserMembership] =
			useRecoilState(membership_rank);
		const [isOpen, setIsOpen] = useRecoilState(InnerModalOpen);
		const [loading, setLoading] = useState(false);
		const [Modalopen, setModalopen] = useState(false);
		const [login, setLogin] = useRecoilState(Login);
		const [mypage, setMypage] = useState(false);
		const textData = useRecoilValue(translatedText);
		const [langModal, setLangModal] = useState(false);
		const [authenticateModal, setAuthenticateModal] = useState(false);
		const [param, setParam] = useState('');
		const history = useHistory();

		const _inputLogAccount = {
			address: address,
			subAddress: userData?.sub_wallet_address,
		};

		const useScroll = () => {
			const [Scroll, setScroll] = useState({
				x: 0,
				y: 0,
			});
			const onScroll = e => {
				setScroll({ y: window.scrollY, x: window.screenX });
			};
			useEffect(() => {
				window.addEventListener('scroll', onScroll);
				return () => window.removeEventListener('scroll', onScroll);
			}, []);
			return Scroll;
		};
		const { y } = useScroll();

		useEffect(() => {
			setParam(window.location.pathname);
			if (param === '/Mypage') {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'마이페이지 접근',
					null
				);
			}
		}, [param]);

		useLayoutEffect(() => {
			if (isConnected) {
				_getMembershipRank(address)
					.then(result => {
						setUserMembership(result);
					})
					.catch(error => {
						setUserMembership('N/A');
					});
			} else {
				setUserMembership('N/A');
			}
		}, [isConnected]);

		useEffect(() => {
			if (navigator.userAgent.indexOf('KAKAO') >= 0)
				alert(textData.alert['onOtherBrowser']);
			if (navigator.userAgent.indexOf('[FB') >= 0)
				alert(textData.alert['onOtherBrowser']);
			if (navigator.userAgent.indexOf('Instagram') >= 0)
				alert(textData.alert['onOtherBrowser']);
			if (navigator.userAgent.indexOf('trill') >= 0)
				alert(textData.alert['onOtherBrowser']);
			let localeLang = localStorage.getItem('locale');
			if (localeLang == null) {
				localStorage.setItem('locale', 'ko');
				localeLang = 'ko';
			}
			setlangmChange(localeLang);
		}, []);

		const onChangelanguageEn = () => {
			setlangmChange('en');
			localStorage.setItem('locale', 'en');
		};

		const onChangelanguageKo = () => {
			setlangmChange('ko');
			localStorage.setItem('locale', 'ko');
		};

		const _myPageRoute = () => {
			history.push({
				pathname: '/Mypage',
			});
		};

		/**
		 * 유저 정보와 지갑 주소를 연동시도
		 * @author ydw <teammapa.ydw@gmail.com>
		 * @function _logout_removeAll
		 * @returns {State} uesrData,isLoggedLogin,SessionSaved,OauthState,walletConnectModal,userAddress,authenticateModal
		 */
		const _logout_removeAll = async () => {
			try {
				if (isConnected) {
					const wallet_unlinking = await post_Wallet_unlinking(
						userData?.index
					);
					const disconnect = await disconnectAsync();
					setUserData(null);
					setIsOpen(false);
					setAuthenticateModal(false);
					history.push({
						pathname: '/',
					});
					sessionStorage.removeItem('login.connector');
				}
			} catch (error) {}
		};

		return (
			<>
				{loading ? <Loading /> : null}
				{Modalopen ? (
					<OAuthModal
						setModalopen={setModalopen}
						Modalopen={Modalopen}
					/>
				) : null}
				<HeaderMobile
					staticModalStyles={staticModalStyles}
					colortype={'dark'}
					account={isConnected}
					setMypage={setMypage}
					mypage={mypage}
					isAuthenticated={isConnected}
					_myPageRoute={_myPageRoute}
					logoutFuc={_logout_removeAll}
					setModalopen={setModalopen}
					OAuthData={userData}
					Modalopen={Modalopen}
					login={isConnected}
					// onLogin={onLogin}
					handleAuth={handleAuth}
					ref={mobileHeaderRef}
					address={address}
				/>
				<StakeModal
					modalVisible={authenticateModal}
					_setModalVisible={setAuthenticateModal}
					onClick={() => {
						// _liking_authenticate();
					}}
				/>
				<div id='headers'>
					<div
						style={
							colortype === 'black'
								? {}
								: { borderBottom: '1px solid #515151' }
						}
						className={
							colortype === 'black' && y >= 20
								? 'header_inner active'
								: colortype !== 'black' && y >= 20
								? 'header_inner start'
								: 'header_inner'
						}>
						<div className='left_content'>
							<NavLink to='/'>
								<div className='logo'>
									<img src={logo} />
								</div>
							</NavLink>
							<NavLink style={{ textDecoration: 'none' }} to='/'>
								<div className='title'>
									{
										<p
											style={
												colortype === 'black'
													? { color: '#111111' }
													: { color: '#ffffff' }
											}>
											Konnect World
										</p>
									}
								</div>
							</NavLink>
						</div>
						<div className='right_content'>
							{textData && (
								<div className='menu_list'>
									<ul>
										<li>
											<NavLink
												style={{
													textDecoration: 'none',
												}}
												to='/'>
												<p
													className={
														param === '/'
															? 'menu_listtext menu_listtext_active'
															: 'menu_listtext'
													}
													style={
														colortype === 'black'
															? {
																	color: '#111111',
															  }
															: {
																	color: '#ffffff',
															  }
													}>
													{' '}
													{textData &&
														textData.header
															.menulist_about}
												</p>
											</NavLink>
										</li>
										<li>
											<NavLink
												style={{
													textDecoration: 'none',
												}}
												to='/Story'>
												<p
													className={
														param === '/Story'
															? 'menu_listtext menu_listtext_active'
															: 'menu_listtext'
													}
													style={
														colortype === 'black'
															? {
																	color: '#111111',
															  }
															: {
																	color: '#ffffff',
															  }
													}>
													{textData &&
														textData.header
															.menulist_story}
												</p>
											</NavLink>
										</li>
										<li>
											{/* <NavLink style={{textDecoration:"none"}} to=""> */}
											<p
												className={
													param === '/nftmarket'
														? 'menu_listtext menu_listtext_active'
														: 'menu_listtext'
												}
												onClick={() => {
													alert(
														textData &&
															textData.header
																.closed
													);
												}}
												style={
													colortype === 'black'
														? { color: '#111111' }
														: { color: '#ffffff' }
												}>
												{textData &&
													textData.header
														.menulist_market}
											</p>
											{/* </NavLink> */}
										</li>
										<li>
											<NavLink
												style={{
													textDecoration: 'none',
												}}
												to='Gallery'>
												<p
													className={
														param === '/Gallery'
															? 'menu_listtext menu_listtext_active'
															: 'menu_listtext'
													}
													style={
														colortype === 'black'
															? {
																	color: '#111111',
															  }
															: {
																	color: '#ffffff',
															  }
													}>
													{textData &&
														textData.header
															.menulist_gallery}
												</p>
											</NavLink>
										</li>
										<li>
											<NavHashLink
												style={{
													textDecoration: 'none',
												}}
												to='/#roadMap'
												activeClassName='kct_Rdoadmap'
												scroll={el =>
													el.scrollIntoView({
														behavior: 'auto',
														block: 'start',
													})
												}
												smooth={false}>
												<p
													className='menu_listtext'
													style={
														colortype === 'black'
															? {
																	color: '#111111',
															  }
															: {
																	color: '#ffffff',
															  }
													}>
													{textData &&
														textData.header
															.menulist_roadMap}
												</p>
											</NavHashLink>
										</li>
									</ul>
								</div>
							)}
							<div
								className='lang'
								onClick={() => {
									setLangModal(!langModal);
								}}>
								<div
									className={
										colortype === 'black'
											? 'globe_logo'
											: 'globe_logos'
									}>
									<img
										style={{ display: 'block' }}
										src={globe}
									/>
								</div>
								<div className='lang_r'>
									<p
										style={
											colortype === 'black'
												? { color: '#111111' }
												: { color: '#ffffff' }
										}>
										{langmChange &&
											langmChange.toUpperCase()}
										{/* 지후작업 (언어변경) */}
									</p>
								</div>
								<div className='language_modal'>
									{langModal ? (
										<Language
											onChangelanguageEn={
												onChangelanguageEn
											}
											onChangelanguageKo={
												onChangelanguageKo
											}
										/>
									) : null}
								</div>
							</div>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}>
								{isConnected ? (
									<div
										className={
											colortype === 'black'
												? 'login_box'
												: 'black_loginbox'
										}>
										<div
											onClick={() => {
												setMypage(!mypage);
											}}
											className={
												colortype === 'black'
													? 'login_box_item'
													: 'black_loginbox_item'
											}
											style={{
												width: '100%',
												height: '100%',
											}}>
											<img
												src={
													userData?.profile_image_url ||
													profileImg
												}
												className={
													colortype === 'black'
														? 'login_box_img'
														: 'black_loginbox_img'
												}
												style={{
													width: '100%',
													height: '100%',
													borderRadius: '50%',
												}}
											/>
										</div>
										{mypage === true &&
										window.innerWidth > 1024 ? (
											<div className='mypage_box'>
												<div>
													<img src={mypage_ico} />
													<div
														onClick={() => {
															_myPageRoute();
														}}>
														<p className='mypage_boxtext'>
															My Page
														</p>
													</div>
												</div>
												<div
													onClick={() => {
														_logout_removeAll();
													}}>
													<img src={logout_ico} />
													<p className='mypage_boxtext'>
														Log Out
													</p>
												</div>
											</div>
										) : null}
									</div>
								) : (
									<div
										className='wallet_btn'
										onClick={async () => {
											await handleAuth();
										}}>
										<p>Login</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
);
const staticModalStyles = {
	position: 'absolute',
	top: 80,
	width: '80%',
	height: '333px',
	padding: '0px',
	borderRadius: '0.25rem',
	background: '#424242',
	animation: 'none',
};

export default Header;
